<div class="import-user">
  <form [formGroup]="form">
    @if (isSuper) {
      <div class="country">
        <mat-form-field>
          <mat-select placeholder="{{'user.country' | translate}}" formControlName="country">
            @for (country of countries; track country.id) {
              <mat-option [value]="country.id">
                <span>{{country.name}}</span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (isSuper || isCountry) {
      <div class="canton">
        <mat-form-field>
          <mat-select placeholder="{{'user.canton' | translate}}" formControlName="canton">
            @for (canton of cantons; track canton) {
              <mat-option [value]="canton.id">
                <span>{{canton.name}}</span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (isSuper || isCountry || isCanton) {
      <div class="organization">
        <mat-form-field>
          <mat-select placeholder="{{'user.organization' | translate}}" formControlName="organization">
            @for (organization of organizations; track organization.id) {
              <mat-option [value]="organization.id">
                <span>{{organization.name}}</span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    <div class="user-role">
      <mat-form-field>
        <mat-select placeholder="{{'user.role' | translate}}" formControlName="role">
          @for (role of roles; track role.value) {
            <mat-option [value]="role.value">
              <span>{{('importCsv.' + role.label) | translate}}</span>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    @if (roleValue == 1) {
      <div class="target-group">
        <mat-form-field>
          <mat-select placeholder="{{'event.target_group' | translate}}" formControlName="target">
            @for (tG of targetGroups; track tG) {
              @if (tG.number < 10) {
                <mat-option  [value]="tG.value">
                  <span>{{tG.label}}</span>
                </mat-option>
              }
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  </form>
  @if (!form.valid) {
    <div class="fill-msg">
      {{'frontUser.fill_before_input' | translate}}
    </div>
  }
  <div class="buttons">
    <div class="button">
      <div class="template">
        <a href="{{fileUrl}}"
        download="Book.csv">{{'template' | translate}}</a>
      </div>


    </div>
    <div class="button">
      <input id="fileInput" type="file" (change)="onFileSelect($event.target)" name="myfile" [disabled]="!form.valid">
      <label for="fileInput" class="file-input-label">
        <mat-icon title="{{'main.upload' | translate}}">file_download</mat-icon>
      </label>
    </div>
    <a href="http://convertcsv.com/csv-viewer-editor.htm" target="_blank">Online CSV EDITOR/VIEWER</a>
  </div>


  @if (userCount) {
    <div>
      <div style="text-align: center; margin-top: 10px">
        @if (notUploadedUser) {
          <span style="color: red; font-weight: bold">{{notUploadedUser}}<span style="color: black;">/</span></span>
        }
        <span style="color: green; font-weight: bold">{{uploadedUser}}<span style="color: black;">/</span></span>
        <span>{{userCount}}</span>
      </div>
      <mat-progress-bar mode="determinate" value="{{procent}}"></mat-progress-bar>
    </div>
  }
  @if (importError.length) {
    <div class="import-error">
      <div class="title">{{'errors' | translate}}</div>
      @for (err of importError; track err; let i = $index) {
        <div class="errors">
          @if (err.errorMsg === 'req_field_error') {
            <span>{{i + 1}}. {{'fill_req_field' | translate}} {{err.position}}</span>
          }
          @if (err.errorMsg === 'row_error_duplicate') {
            <span>{{i + 1}}. {{'row_error_duplicate' | translate}} {{err.position}}</span>
          }
          @if (err.errorMsg === 'wrong_email') {
            <span>{{i + 1}}. {{'wrong_email' | translate}} {{err.position}}</span>
          }
          @if (err.errorMsg === 'email_error') {
            <span>{{i + 1}}. {{err.email}} {{'email_error' | translate}} {{err.position}}</span>
          }
          @if (err.errorMsg === 'email_error_duplicate') {
            <span>{{i + 1}}. {{err.email}} {{'email_error_duplicate' | translate}} {{err.position}}</span>
          }
          @if (err.errorMsg === 'phone_error') {
            <span>{{i + 1}}. {{'phone_error' | translate}} {{err.position}}</span>
          }
          @if (err.errorMsg === 'mobile_error') {
            <span>{{i + 1}}. {{'mobile_error' | translate}} {{err.position}}</span>
          }
        </div>
      }
    </div>
  }
  @if (importedUser.length) {
    <div class="imported-users">
      <div class="title">{{'imported' | translate}}</div>
      @for (user of importedUser; track user; let i = $index) {
        <div class="users">
          <span>{{i + 1}}. {{user.user}}</span>
        </div>
      }
    </div>
  }
</div>
